// @mui
import { Container, Stack, Box } from '@mui/material';
// components

import InputForm from 'src/components/organisms/company/company-input-form';
import HeadLineText from 'src/components/atoms/head-line-text';

export default function CompanyEditTemplate({ OnSubmit, title, responseData }: any) {
  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} ml={1} mt={'3%'} mr={0}>
        <HeadLineText text={title} />

        <Box />
      </Stack>

      <InputForm editForm OnSubmit={OnSubmit} defaultValues={responseData} />
    </Container>
  );
}
